"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function default_1(isScrollable = true) {
    const activeStyle = 'cursor: grabbing; cursor: -webkit-grabbing;';
    const [scrollDiv, setScrollDiv] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!!scrollDiv && isScrollable) {
            let isDown = false;
            let startX;
            let scrollLeft;
            const onMouseDown = (e) => {
                isDown = true;
                scrollDiv.setAttribute('style', activeStyle);
                startX = e.pageX - scrollDiv.offsetLeft;
                scrollLeft = scrollDiv.scrollLeft;
            };
            const onMouseUp = () => {
                isDown = false;
                scrollDiv.removeAttribute('style');
            };
            const onMouseMove = (e) => {
                if (!isDown)
                    return;
                e.preventDefault();
                e.stopPropagation();
                const x = e.pageX - scrollDiv.offsetLeft;
                const walk = (x - startX) * 3; // ? scroll-fast
                scrollDiv.scrollLeft = scrollLeft - walk;
            };
            scrollDiv.addEventListener('mousedown', onMouseDown);
            scrollDiv.addEventListener('mouseup', onMouseUp);
            scrollDiv.addEventListener('mouseleave', onMouseUp);
            scrollDiv.addEventListener('mousemove', onMouseMove);
            return () => {
                scrollDiv.removeEventListener('mousedown', onMouseDown);
                scrollDiv.removeEventListener('mouseup', onMouseUp);
                scrollDiv.removeEventListener('mouseleave', onMouseUp);
                scrollDiv.removeEventListener('mousemove', onMouseMove);
            };
        }
    }, [scrollDiv, isScrollable]);
    const centerTarget = (target) => {
        if (target && !!scrollDiv && isScrollable) {
            const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
            const { left: scrollDivLeft } = scrollDiv.getBoundingClientRect();
            const { scrollLeft, clientWidth } = scrollDiv;
            const scrollX = targetLeft - scrollDivLeft + targetWidth / 2 + scrollLeft - clientWidth / 2;
            scrollDiv.scrollTo({ behavior: 'smooth', left: scrollX });
        }
    };
    return { scrollDiv, setScrollDiv, centerTarget };
}
exports.default = default_1;
